export enum NDDFilterOperatorValues {
    Contains = 1,
    Equals = 2,
    Different = 3,
    GreaterThan = 4,
    GreaterThanOrEquals = 5,
    LessThan = 6,
    LessThanOrEqual = 7,
    Interval = 8,
    StartsWith = 9,
    EndsWith = 10,
}

export enum NDDFilterLogicalOperatorsTypes {
    None = 0,
    And = 1,
    Or = 2,
}

export enum NDDFilterTypes {
    String = 0,
    Boolean = 1,
    Date = 2,
    Number = 3,
    Time = 4,
}

export enum NDDFilterControlKeys {
    Filter = 'rules',
    SimpleValue = 'simpleValue',
    OptionValue = 'optionValue',
    IntervalValue = 'intervalValue',
    InitialValue = 'initialValue',
    InitialValueTime = 'initialValueTime',
    FinalValue = 'finalValue',
    FinalValueTime = 'finalValueTime',
}
